import React from 'react';
import { CheckIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-4 md:py-5 px-4 text-center" data-id="element-382">
      <div className="max-w-4xl mx-auto" data-id="element-383">
        <span className="inline-block bg-blue-100 text-blue-800 text-sm font-bold px-3 py-1 rounded-full mb-1 uppercase tracking-wide" data-id="element-384">
          La Solución
        </span>

        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-3" data-id="element-385">
          ✅ CON ESTE KIT VAS A PODER:
        </h2>

        <div className="space-y-2 text-left max-w-3xl mx-auto" data-id="element-386">
          <div className="flex items-start gap-2 bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-387">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-388">
              <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-389" />
            </div>
            <span className="text-base font-bold text-gray-800" data-id="element-390">
              Dar clases de educación financiera con material 100% argentino y
              actualizado
            </span>
          </div>

          <div className="flex items-start gap-2 bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-391">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-392">
              <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-393" />
            </div>
            <span className="text-base font-bold text-gray-800" data-id="element-394">
              Tener actividades y evaluaciones listas sin preparar nada
              adicional
            </span>
          </div>

          <div className="flex items-start gap-2 bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-395">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-396">
              <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-397" />
            </div>
            <span className="text-base font-bold text-gray-800" data-id="element-398">
              Cumplir con los NAP 2026 y justificar ante directivos con rúbricas
              por capacidades
            </span>
          </div>

          <div className="flex items-start gap-2 bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-399">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-400">
              <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-401" />
            </div>
            <span className="text-base font-bold text-gray-800" data-id="element-402">
              Conectar con tus alumnos usando ejemplos reales: el dólar, el
              CEDEARs, las estafas de WhatsApp
            </span>
          </div>

          <div className="flex items-start gap-2 bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-403">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-404">
              <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-405" />
            </div>
            <span className="text-base font-bold text-gray-800" data-id="element-406">
              Ahorrar horas de trabajo cada semana
            </span>
          </div>
        </div>
      </div>
    </section>;
}